import { FieldInput } from "components/FieldInput";
import { formatDate, isValidDate } from "helpers/date";
import React from "react";

type CustomDatePickerInputProps = {
  onClick?: () => void;
  onChange?: () => void;
  value?: string;
  inputName: string;
  label?: string;
  localeCode?: string;
};

export const CustomDatePickerInput = React.forwardRef<
  HTMLInputElement,
  CustomDatePickerInputProps
>(function CustomInput(
  { onClick, onChange, value, label, inputName = "date", localeCode },
  ref,
) {
  return (
    <FieldInput
      onClick={onClick}
      format={(value) => {
        if (typeof value === "string") {
          return value;
        }
        return isValidDate(value) ? formatDate(value, localeCode) : value;
      }}
      name={inputName}
      label={label}
      placeholder={localeCode === "enUS" ? "MM/DD/YYYY" : "DD/MM/YYYY"}
      onChange={onChange}
      value={value}
      ref={ref}
      browserAutofillOffValue="off"
    />
  );
});
